import { Client, IMessage } from '@stomp/stompjs';
import * as SockJS from 'sockjs-client';
import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { filter, firstValueFrom, take } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private client!: Client;
  private connected = false;

  constructor(private auth: AuthService) {}

  connect(onMessage: (msg: string) => void) {
    if (this.connected) return;

    this.client = new Client({
      webSocketFactory: () => new SockJS(`${environment.apiServer}/ws`),
      reconnectDelay: 5000,
      // The SockJS handshake cannot carry an Authorization header, so the backend authenticates the
      // STOMP CONNECT frame instead (StompAuthenticationInterceptor). Two reasons this lives in
      // beforeConnect rather than in a connectHeaders literal: connect() runs from AppComponent
      // ngOnInit, before Auth0 has resolved the session, and reconnectDelay makes the client retry
      // on its own -- a header captured once would keep replaying an expired token forever.
      beforeConnect: async () => {
        await firstValueFrom(this.auth.isAuthenticated$.pipe(filter(Boolean), take(1)));
        const token = await firstValueFrom(this.auth.getAccessTokenSilently());
        this.client.connectHeaders = { Authorization: `Bearer ${token}` };
      },
    });

    this.client.onConnect = () => {
      console.log("✅ WebSocket CONNECTED");
      this.connected = true;
      this.client.subscribe('/topic/routine', (message: IMessage) => {
        const data = JSON.parse(message.body);
        onMessage(data);
      });
    };

    this.client.activate();
  }
}
